<script>
import LoadingTextTemplatesTable from './LoadingTextTemplatesTable'

export default {
  name: 'MobilizeV2TextTemplateList',
  components: {
    LoadingTextTemplatesTable
  },
  data() {
    return {
      search: ''
    }
  }
}
</script>

<template>
  <div class="mobilizev2-view">
    <v-row>
      <v-col sm="auto" md="auto" lg="auto" xl="auto">
        <h1>Text Templates</h1>
      </v-col>
      <v-spacer />
      <v-text-field v-model="search" append-icon="search" label="Search"></v-text-field>
      <v-col sm="auto" md="auto" lg="auto" xl="auto">
        <v-btn to="/mobilizev2/text-templates/new" color="primary" class="mini-hidden">
          <v-icon left dark>add</v-icon>
          Create new text template
        </v-btn>
      </v-col>
    </v-row>
    <loading-text-templates-table />
  </div>
</template>

<style lang="scss" scoped></style>
